import { render } from "./CompatibilityNotice.vue?vue&type=template&id=d044bb48&scoped=true"
import script from "./CompatibilityNotice.vue?vue&type=script&lang=js"
export * from "./CompatibilityNotice.vue?vue&type=script&lang=js"

import "./CompatibilityNotice.vue?vue&type=style&index=0&id=d044bb48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d044bb48"]])

export default __exports__